import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Button from '../Button/Button';
import DateInput from '../DateInput/DateInput';
import Group from '../Group/Group';
import Input from '../Input/Input';
import Lightbox from '../Lightbox/Lightbox';
import Menu from '../Menu/Menu';
import Select from '../Select/Select';
import SaveState from '../../constants/SaveState';
import TransitionGroup from '../TransitionGroup/TransitionGroup';

const SAVE_STATES = [SaveState.NONE, SaveState.SAVING, SaveState.SAVED, SaveState.ERROR];

class LightboxExample extends Component {

  state = {
    title: 'Lightbox example',
    saveState: 0,
    fields: [{
      name: 'ID',
      value: 5709,
    }, {
      name: 'Published',
      value: true,
    }, {
      name: 'Created',
      value: '9 months ago',
    }, {
      name: 'Last Updated',
      value: 'a month ago',
    }, {
      name: 'Created by',
      value: 'You',
    }],
  };

  onChange = e => this.setState(e.target.value);

  onClick = e => this.setState({ open: true });

  onClose = e => this.setState({ open: false });

  onToggleState = e => this.setState({ saveState: (this.state.saveState + 1) % SAVE_STATES.length });

  renderLightbox = () => {
    return (
      <Lightbox {...this.state} saveState={SAVE_STATES[this.state.saveState]} onClose={this.onClose}>
        <Group>
          <Input label="Value"/>
          <Select options={['Option 1', 'Option 2']}/>
          <DateInput onChange={() => {}}/>
          <Menu buttonClass="core-icon-button primary">
            <Button>Item 1</Button>
            <Button>Item 2</Button>
          </Menu>
          <Button onClick={this.onToggleState}>Cycle Save States</Button>
        </Group>
      </Lightbox>
    );
  };

  render() {
    const { open } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Lightbox.defaultProps} propTypes={Lightbox.propTypes} propValues={this.state}/>
        <div className="trigger-buttons">
          <Button onClick={this.onClick}>Open Lightbox</Button>
          <Menu buttonClass="core-icon-button">
            <Button onClick={this.onClick} iconName="edit">Edit</Button>
          </Menu>
        </div>
        <SourceCode querySelector=".core-lightbox" title="Generated HTML (expand and click open lightbox)"/>
        <TransitionGroup in={open} className="animate-lightbox" contentRenderer={this.renderLightbox}/>
      </Example>
    );
  }

}

LightboxExample.tags = 'dialog modal';

export default LightboxExample;
